export const ACCESS_TOKEN_MAX_AGE_SECOND = 60 * 30 - 30;

export const REFRESH_TOKEN_MAX_AGE_SECOND = 60 * 60 * 24 * 30 - 30;
